var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayedSections.length > 0
    ? _c(
        "div",
        { staticClass: "sales-report__section sales-section__nav" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "affix",
            {
              staticClass: "sales-nav vue-affix affix-top",
              attrs: {
                "relative-element-selector": "#sales-report__affix-anchor",
                offset: { top: -36, bottom: 0 }
              }
            },
            [
              _c(
                "div",
                { staticClass: "sales-nav__container" },
                [
                  _vm._l(_vm.displayedSections, function(section) {
                    return [
                      section == "Locations"
                        ? _c(
                            "a",
                            {
                              staticClass: "sales-nav__item",
                              class:
                                "sales-nav__item--" + section.replace(" ", ""),
                              attrs: { href: "#a_" + section }
                            },
                            [
                              _vm._v(_vm._s(section)),
                              _c("span", { staticClass: "sales-nav__pill" }, [
                                _vm._v(_vm._s(_vm.contents.locations.length))
                              ])
                            ]
                          )
                        : section == "Practices"
                        ? _c(
                            "a",
                            {
                              staticClass: "sales-nav__item",
                              class:
                                "sales-nav__item--" + section.replace(" ", ""),
                              attrs: { href: "#a_" + section }
                            },
                            [
                              _vm._v(_vm._s(section)),
                              _c("span", { staticClass: "sales-nav__pill" }, [
                                _vm._v(_vm._s(_vm.contents.businesses.length))
                              ])
                            ]
                          )
                        : _c(
                            "a",
                            {
                              staticClass: "sales-nav__item",
                              class:
                                "sales-nav__item--" + section.replace(" ", ""),
                              attrs: { href: "#a_" + section.replace(" ", "") }
                            },
                            [_vm._v(_vm._s(section))]
                          )
                    ]
                  }),
                  _vm._v(" "),
                  _vm.loadingSections
                    ? _c(
                        "div",
                        { staticClass: "sales-nav__item h-center-align" },
                        [
                          _c("MoonLoader", {
                            attrs: { size: "25px", color: "#ffffff" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "sales-report-body__header-section",
        attrs: { id: "summary-title" }
      },
      [
        _c("div", { staticClass: "sales-report-body__section-title" }, [
          _vm._v("Report Navigation")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }